var ImageGallery = function(options) {

    _.extend(this, options);

    this.configure = function(e) {
        e.click($.proxy(this.show, this));
    };


    this.show = function(e) {

        e.preventDefault();

        if (!this.images || this.images.length == 0) {
            return;
        }

        //this.div = $('<div>');
        //this.renderImages();

        $(e).lightGallery({
            dynamic: true,
            dynamicEl: this.images

        });

    };


    this.renderImages = function() {

        var self = this;

        var i = 0;

        $.each(this.images,
            function() {

                var a = $("<a>", { href: this.src });
                self.div.append(a);

                if (i == 0)
                    self.a = a;

                var img = $("<img>", { src: this.src });
                a.append(img);

                i++;
            });
    };

};


$.fn.ImageGallery = function(options) {

    var gallery = new ImageGallery(options);
    gallery.configure(this);

};